import { Crop } from 'lucide-react';

/* SPEC-506 — the persistent "Feedback" pill, bottom right on every page.
 * A text label in the neutral surface colours: never red (it is not an alarm) and never a
 * chat bubble (the copilot owns that shape). Sits above the desktop status bar and, on a
 * phone, above the copilot's round button. Moves left of the copilot drawer when it is open.
 * `data-feedback-ui` keeps it out of its own screenshot. */
export function FeedbackPill({ onOpen, unread, chatOpen }: { onOpen: () => void; unread: boolean; chatOpen: boolean }) {
  return (
    <button
      type="button"
      data-feedback-ui=""
      data-tour="feedback-pill"
      onClick={onOpen}
      title="Feedback — snip the page and tell us what looks wrong, what broke, or an idea (Cmd/Ctrl+Shift+F)"
      className={`fixed z-30 bottom-20 right-4 md:bottom-10 ${chatOpen ? 'md:right-[496px]' : 'md:right-5'} flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-[var(--border-default)] bg-[var(--bg-raised)] text-xs font-medium text-[var(--text-secondary)] shadow-lg hover:text-[var(--text-primary)] hover:border-amber-500/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/60 transition-colors`}
    >
      <Crop className="w-3.5 h-3.5" aria-hidden="true" />
      <span>Feedback</span>
      {unread && (
        <span className="w-2 h-2 rounded-full bg-amber-400" aria-label="A report you filed has changed status" />
      )}
    </button>
  );
}
